// Stores constants for user roles and their respective
// navigation paths for signin

const userRoleConfig = {
  Subscriber: {
    changeType: "user",
    navigateTo: "/user/dashboard",
  },
  Admin: {
    changeType: "admin",
    navigateTo: "/admin/user_management",
  },
  // Add more roles as needed
};

export default userRoleConfig;
